import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../product/style/categoryList.css';
import Breadcrumb from '../../Component/breadcrumb/Breadcrumb';
import SearchFilter from '../../Component/search/Searchlist';
import MobileFilter from '../../Component/Layout/MobileFilter/MobileFilter';
import ProductShorting from '../../Component/Common/ProductShorting';
import SearchMobile from '../../Component/search/SearchMobile';

const ProducListCarpet = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      // Replace this with your actual data fetching logic
      const fetchedProducts = Array.from({ length: 8 }).map((_, index) => ({
        id: index,
        name: 'Rosa Polyester Neo Classical Carpet Beige',
        image:
          'https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2c-img/EnvogueImages/product/8907831289227/8907831289227.jpg',
      }));
      setProducts(fetchedProducts);
      setLoading(false);
    }, 2000); // Simulate a 2-second loading time
  }, []);

  return (
    <>
    <Breadcrumb />

    <div className="productlist-header serachsectionlisting">
      <div className="container mb-1">
          <div className="row">
            <div className="col col-md-6">
                <p>
                    Showing {products.length} items
                </p>
            </div>
             <div className="col col-md-6">
                   <div className='d-flex' style={{ justifyContent: "flex-end" }} >  
                         <SearchMobile/>
                         <ProductShorting/>
                         <div className="FILTERMOBILE w-00M">
                         <MobileFilter />
                     </div> 
                   </div>
               </div>
           </div> 
        </div>
     </div>

      <section className="category-List">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-3 col-md-3 col-sm-6 col-12 min-Width">
              <h3 style={{ fontSize: '14px', color: '#676464' }} className="FILTER-DESKTOP">
                Filter
              </h3>
              <div className="FILTER-DESKTOP">
                <FilterAllProduct />
              </div>
            </div> */}
            <div className="col-lg-12 col-md-12 col-sm-6 col-12">
            <div className='Bardcom-Desktop-filter'> 
              <div className="row">
                <div className="col-md-2 col-12 w-Widths">
                  <div style={{ display: "flex", flexDirection: "row-reverse", justifyContent: "space-between" }}>  
                  <div className="FILTER-MOBILE">
                    <MobileFilter />
                   </div> 
                   <p style={{ textAlign: 'left', color: 'rgb(127 127 127)', marginBottom: "0", marginTop: "2px" }}>
                      Showing {products.length} items
                    </p>
                  </div>
                </div>
                <div className="col-md-7 col-7 M-Right">
                     <SearchFilter />
                </div>
                <div className="col-md-3 col-5">
                 <div className='d-flex' style={{ justifyContent: "flex-end" }} >  
                    <ProductShorting/>
                    <MobileFilter />
                 </div>
                </div>
              </div>
            </div>
              
            <div className="row">
                {loading
                  ? Array.from({ length: 8 }).map((_, index) => (
                      <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-6">
                        <div className="border-0 p-0 mt-1">
                          <Skeleton height={200} style={{ borderRadius: '0px' }} />
                          <div className="text-center mt-1">
                            <Skeleton width={`80%`} />
                          </div>
                        </div>
                      </div>
                    ))
                  : products.map((product) => (
                      <div key={product.id} className="col-lg-3 col-md-4 col-sm-6 col-6">
                        <div className="border-0 p-0 mt-1">
                          <div className="relative overflow-hidden mb-1">
                            <Link to="/productdetails" className="block">
                              <img
                                src={product.image}
                                className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-10"
                                alt={product.name}
                                style={{ borderRadius: '0px' }}
                              />
                            </Link>
                          </div>
                          <div className="text-center mt-1" style={{ backgroundColor: "rgb(242 242 242)", borderRadius:"3px" }}>
                            <Link to="/" className="text-gray-600 text-lg text-decoration-none">
                              {product.name}
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
              </div> 
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ProducListCarpet;
